import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useCleanupRun = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (companyId: string) =>
      api.post(`admin/companies/${companyId}/transcript-tester/cleanup`),
  });

  return { cleanup: mutateAsync, isCleaning: isPending };
};
